module.exports = __webpack_public_path__ + "img/cat-05.9850b62e.png";